
        <siq-day-weather-landscape *ngFor="let day of days$ | async; trackBy: dayTrackByFn"
                                   [weatherData]="day"
                                   [shortTemperatureFormat]="shortTemperatureFormat"
                                   style="height: 33%">
        </siq-day-weather-landscape>
    